const BASE_PATH = "https://www.thenorthface.com";
const locale = document
  .querySelector("[data-view-id]")
  .getAttribute("data-view-id");

export const getPublicBundleList = async (params = {}) => {
  params.view_id = document.getElementById("root").dataset.viewId;
  params.orderBy = "cross_order";
  let query = Object.keys(params)
    .map((key) => key + "=" + params[key])
    .join("&");
  let res = await fetch(`${process.env.REACT_APP_API_URL}/bundles?${query}`, {
    headers: getCommonHeaders(),
  });
  let data = await res.json();
  data.status = res.status;
  return data;
};

export const getPublicBundleGroupList = async (params = {}) => {
  params.view_id = document.getElementById("root").dataset.viewId;
  params.orderBy = "cross_order";
  let query = Object.keys(params)
    .map((key) => key + "=" + params[key])
    .join("&");
  let res = await fetch(`${process.env.REACT_APP_API_URL}/bundle-group?${query}`, {
    headers: getCommonHeaders(),
  });
  let data = await res.json();
  data.status = res.status;
  return data;
};

export const getPublicCollectionGroupList = async (params = {}) => {
  params.view_id = document.getElementById("root").dataset.viewId;
  let query = Object.keys(params)
    .map((key) => key + "=" + params[key])
    .join("&");
  let res = await fetch(`${process.env.REACT_APP_API_URL}/collection-group?${query}`, {
    headers: getCommonHeaders(),
  });
  let data = await res.json();
  data.status = res.status;
  return data;
};

export const getProductsPrices = async (products) => {
  try{
    const params = {
      products,
      view_id: document.getElementById("root").dataset.viewId,
    };
    let query = Object.keys(params)
      .map((key) => key + "=" + params[key])
      .join("&");
    let res = await fetch(`${process.env.REACT_APP_API_URL}/products/list?${query}`, {
      headers: getCommonHeaders(),
    });
    let data = await res.json();
    data.status = res.status;
    return data;
  }catch(e){
    console.error(e)
    return []
  };
}

const generateUUID = () => {
  // Public Domain/MIT
  var d = new Date().getTime(); //Timestamp
  var d2 =
    (typeof performance !== "undefined" &&
      performance.now &&
      performance.now() * 1000) ||
    0; //Time in microseconds since page-load or 0 if unsupported
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = Math.random() * 16; //random number between 0 and 16
    if (d > 0) {
      //Use timestamp until depleted
      r = (d + r) % 16 | 0;
      d = Math.floor(d / 16);
    } else {
      //Use microseconds since page-load if supported
      r = (d2 + r) % 16 | 0;
      d2 = Math.floor(d2 / 16);
    }
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
};

const getHeaders = () => {
  const headers = new Headers();
  headers.append("Content-Type", "application/json");

  headers.append("siteId", "TNF-" + locale.split("_")[1]);
  headers.append("locale", locale);
  headers.append("channel", "ECOMM");
  headers.append("source", "ECOM15");
  headers.append("region", "EMEA");
  headers.append("brand", "TNF");
  headers.append("x-transaction-id", generateUUID());

  return headers;
};

const getCommonHeaders = () => {
  const headers = new Headers();
  const tokenKey = process.env.REACT_APP_REQUEST_LOCALHOST_TOKEN_HEADER_KEY;
  const tokenValue = process.env.REACT_APP_REQUEST_LOCALHOST_TOKEN_HEADER_VALUE;
  if(tokenKey && tokenValue)
  {
    headers.append(tokenKey, tokenValue);
  }
  return headers;

};

export const getProduct = async (productId) => {
  const referrer = process.env.NODE_ENV === "production" ? undefined : "";
  const basePath = process.env.NODE_ENV === "production" ? "" : BASE_PATH;

  //if (productId == 'NF0A8BBT59J') {
  //let file = "NF0A8FH2682.json";
  //}

  /*const response = await fetch("./json-product/" + file, {
      headers: getHeaders()
  })*/


  const response = await fetch(
    basePath +
      "/api/products/v2/products/" +
      encodeURIComponent(productId) +
      "/details" +
      "?locale=" +
      locale.toLowerCase().replace(/_/g, "-"),
    {
      headers: getHeaders(),
      referrer: referrer,
    },
  );

  return await response.json();
};

export const addToBasket = async (products, isBundlePage) => {
  let cartProducts;
  if (!isBundlePage) {
    const toBuyProducts = Object.keys(products).filter(
      (sku) => products[sku].toBuy,
    );
    cartProducts = Object.keys(products)
      .map((sku) => {
        return toBuyProducts.includes(sku) ? products[sku].catId : null;
      })
      .filter((sku) => sku);
  } else {
    cartProducts = Object.keys(products).map((sku) => {
      return products[sku].catId;
    });
  }

  const addToCartEvent = new CustomEvent("add-to-cart", {
    detail: cartProducts,
  });

  // Get the bundle container element
  const element = document.getElementById("root");
  // Dispatch the event on the finder container
  element.dispatchEvent(addToCartEvent);

  return true;
};
